export default __webpack_public_path__ + "static/media/gallery-img-2.a667d860.jpg";